import { useCallback, useState } from "react";
import { BatchDialog } from "../BatchDialog";

export const useBatchResult = (title, result, closeBatchDialog) => {
    const [promise, setPromise] = useState(null);

    const openDialog = useCallback(
        () =>
            new Promise((resolve, reject) => {
                setPromise({ resolve });
            }),
        []
    );

    const handleClose = () => {
        setPromise(null);
        closeBatchDialog();
    };

    const handleCancel = () => {
        promise?.resolve(false);
        handleClose();
    };
    const DialogBatch = (): JSX.Element => {
        return (
            <>
                <BatchDialog
                    onClose={handleCancel}
                    open={promise !== null}
                    title={title}
                    result={result}
                />
            </>
        );
    };
    return { DialogBatch, openDialog };
};
